"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectModuleSchema = exports.ProjectModuleInstanceSchema = void 0;
const zod_1 = require("zod");
const StandardComponentModel_1 = require("./StandardComponentModel");
const metadata_1 = require("./metadata");
exports.ProjectModuleInstanceSchema = zod_1.default.object({
    ref: zod_1.default.string(),
    designId: zod_1.default.string(),
});
exports.ProjectModuleSchema = zod_1.default.object({
    name: zod_1.default.string(),
    instances: exports.ProjectModuleInstanceSchema.array(),
    metadata: metadata_1.MetadataSchema.optional(),
    value: zod_1.default.string().optional(),
    isDnp: zod_1.default.boolean().optional(),
    hideInBom: zod_1.default.boolean().optional(),
    model: StandardComponentModel_1.StandardComponentModelSchema.optional(),
    componentRef: zod_1.default.string(),
    catalogRef: zod_1.default.string().optional(),
});
//# sourceMappingURL=ProjectModule.js.map